import CryptoJS from "crypto-js/crypto-js";

// Default KEY and iv if not given
const AES_SECRET_KEY = process.env.AES_SECRET_KEY || "";
const KEY = CryptoJS.enc.Utf8.parse(AES_SECRET_KEY.substring(0, 16));
const IV = CryptoJS.enc.Utf8.parse(AES_SECRET_KEY.substring(0, 16));

/**
 * AES Encryption: the string key iv returns base64
 */
export function Encrypt(word, keyStr) {
  let key = KEY;
  let iv = IV;

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(keyStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });

  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/**
 * AES Decryption: the string key iv returns base64
 *
 */
export function Decrypt(word, keyStr) {
  let key = KEY;
  let iv = IV;

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(keyStr);
  }

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}
